var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { registerSystem } from "../ComponentRegistry.js";
import { C as ComponentCategory } from "../../enums-86f58524.js";
import { C as CameraFollowOnSpawnSchema } from "../../CameraFollowOnSpawn-16a4734f.js";
import { EntityCameraSchema } from "./EntityCamera.js";
import "../../decorators/type.js";
import "ajv";
import "../../utils/clone.js";
import "bitecs";
import "../../utils/typehelpers.js";
import "../../global-33d5eebf.js";
import "../types.js";
import "../../utils/byteArray.js";
import "../../Transform-9450b7b5.js";
class CameraFollowOnSpawnSystem {
  constructor() {
    __publicField(this, "type", "CameraFollowOnSpawn");
    __publicField(this, "category", ComponentCategory.CORE);
    __publicField(this, "schema", CameraFollowOnSpawnSchema);
  }
  init(entity, gameModel) {
    gameModel.getTypedUnsafe(gameModel.coreEntity, EntityCameraSchema).entity = entity;
  }
}
registerSystem(CameraFollowOnSpawnSystem);
export {
  CameraFollowOnSpawnSystem
};
//# sourceMappingURL=CameraFollowOnSpawn.js.map
